export interface GalleryItem {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  date: string;
  category: string;
}

export const galleryItems: GalleryItem[] = [
  {
    id: "g1",
    title: "和服系列 - 清水寺",
    description: "京都清水寺前的振袖和服写真",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20wearing%20elegant%20colorful%20furisode%20kimono%20at%20Kiyomizudera%20temple%20in%20Kyoto%2C%20traditional%20wooden%20architecture%20background%2C%20warm%20autumn%20sunlight%2C%20graceful%20pose%2C%20fine%20art%20portrait%20photography%2C%20soft%20cream%20and%20vermilion%20tones&width=800&height=1067&seq=gallery-001&orientation=portrait",
    date: "2024-10-15",
    category: "kimono",
  },
  {
    id: "g2",
    title: "杂志封面 - 周刊现代",
    description: "2024年12月号封面拍摄花絮",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20in%20modern%20fashion%20magazine%20cover%20style%2C%20professional%20studio%20lighting%2C%20chic%20elegant%20outfit%2C%20clean%20white%20background%2C%20editorial%20fashion%20photography%2C%20sophisticated%20composition%2C%20warm%20neutral%20tones&width=800&height=1067&seq=gallery-002&orientation=portrait",
    date: "2024-11-20",
    category: "magazine",
  },
  {
    id: "g3",
    title: "活动写真 - 粉丝见面会",
    description: "东京巨蛋粉丝见面会舞台写真",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20in%20white%20dress%20waving%20to%20audience%20on%20stage%2C%20concert%20lighting%2C%20grand%20atmosphere%2C%20warm%20spotlight%2C%20performance%20photography%2C%20elegant%20and%20energetic%20composition&width=800&height=1067&seq=gallery-003&orientation=portrait",
    date: "2024-08-18",
    category: "event",
  },
  {
    id: "g4",
    title: "生活写真 - 咖啡时光",
    description: "东京街头的休闲日常",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20enjoying%20coffee%20at%20a%20stylish%20cafe%2C%20natural%20window%20light%2C%20casual%20chic%20outfit%2C%20warm%20cozy%20atmosphere%2C%20lifestyle%20photography%2C%20relaxed%20candid%20composition%2C%20soft%20cream%20and%20beige%20tones&width=800&height=1067&seq=gallery-004&orientation=portrait",
    date: "2024-09-12",
    category: "lifestyle",
  },
  {
    id: "g5",
    title: "樱花系列 - 上野公园",
    description: "春季樱花树下的浪漫写真",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20under%20blooming%20cherry%20blossom%20trees%20in%20spring%2C%20pink%20petals%20falling%2C%20soft%20sunlight%20through%20branches%2C%20dreamy%20romantic%20atmosphere%2C%20fine%20art%20portrait%20photography%2C%20gentle%20pink%20and%20cream%20tones&width=800&height=1067&seq=gallery-005&orientation=portrait",
    date: "2024-04-05",
    category: "seasonal",
  },
  {
    id: "g6",
    title: "颁奖典礼 - 红毯造型",
    description: "年度艺人影响力颁奖典礼",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20in%20elegant%20evening%20gown%20on%20red%20carpet%2C%20glamorous%20award%20ceremony%2C%20flashing%20cameras%2C%20sophisticated%20pose%2C%20celebrity%20event%20photography%2C%20warm%20golden%20and%20cream%20tones&width=800&height=1067&seq=gallery-006&orientation=portrait",
    date: "2024-10-20",
    category: "event",
  },
  {
    id: "g7",
    title: "夏日海滩系列",
    description: "冲绳海滩度假写真",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20in%20summer%20dress%20on%20a%20tropical%20beach%2C%20turquoise%20ocean%20background%2C%20golden%20sunset%20light%2C%20relaxed%20vacation%20atmosphere%2C%20travel%20photography%2C%20warm%20and%20breezy%20composition%2C%20soft%20cream%20and%20coral%20tones&width=800&height=1067&seq=gallery-007&orientation=portrait",
    date: "2024-07-28",
    category: "seasonal",
  },
  {
    id: "g8",
    title: "慈善活动 - 灾区慰问",
    description: "能登半岛地震灾区慰问活动",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20playing%20with%20children%20in%20a%20classroom%2C%20warm%20caring%20smile%2C%20casual%20compassionate%20outfit%2C%20soft%20natural%20lighting%2C%20documentary%20style%20photography%2C%20heartwarming%20atmosphere%2C%20gentle%20cream%20and%20earth%20tones&width=800&height=1067&seq=gallery-008&orientation=portrait",
    date: "2024-05-05",
    category: "charity",
  },
];